var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 26,
    viewBox: "0 0 21 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "currentColor",
    d: "M3.61719 17.7109V11.2905C3.61719 8.1404 5.81869 5.50163 8.78679 4.78477C9.30989 4.65321 9.85618 4.58743 10.4185 4.58743C11.0396 4.58743 11.6412 4.66874 12.215 4.8277C13.3709 5.13741 14.4047 5.73826 15.2263 6.54801C16.457 7.76461 17.2196 9.43832 17.2196 11.2905V17.7109",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "currentColor",
    d: "M17.2167 17.7072H18.2861C19.2294 17.7072 20 18.4627 20 19.3967C20 19.8654 19.8075 20.2838 19.497 20.5899C19.1861 20.8959 18.7579 21.0859 18.2861 21.0859H17.2167H13.3167H7.47474H3.61431H2.71393C1.76659 21.0859 1 20.3304 1 19.3967C1 18.9277 1.1925 18.5093 1.50303 18.2032C1.80985 17.8972 2.24211 17.7072 2.71393 17.7072H3.61431",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "currentColor",
    d: "M8.78125 4.78549V2.6894C8.78125 1.7554 9.54784 0.999851 10.4952 0.999851C10.967 0.999851 11.3996 1.18988 11.7061 1.49593C12.0166 1.79803 12.2094 2.22437 12.2094 2.6894V4.82812",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "currentColor",
    d: "M13.3185 21.0904V22.121C13.3185 23.7097 12.0134 25 10.3974 25C9.59155 25 8.8605 24.6784 8.33368 24.1552C7.80285 23.636 7.47656 22.9155 7.47656 22.121V21.0904",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notification-icon.6f63ae52b3311344f7a446c8e784e823.svg";
export { ForwardRef as ReactComponent };